var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArticle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Article/Transparent - WithoutCircle",
    clipPath: "url(#clip0_577_171098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Article"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M108.802 176.111H185.659C188.057 176.111 189.992 174.167 189.992 171.778V97.0553C189.992 95.741 189.395 94.5063 188.375 93.678L163.922 73.9638C163.149 73.3425 162.193 73 161.198 73H108.802C106.404 73 104.469 74.9435 104.469 77.3331V171.77C104.469 174.167 106.412 176.103 108.802 176.103V176.111Z",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M119.085 125.205H156.283",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M119.085 141.892H172.739",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M171.991 158.794H119.085",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M104.468 75.8676L69.668 81.2761C67.3023 81.6425 65.6854 83.8568 66.0518 86.2225L80.5407 179.536C80.9071 181.902 83.1294 183.527 85.4951 183.152L130.404 176.087",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M87.8369 131.282L104.277 128.733",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M90.4017 147.771L104.198 145.628",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M104.365 162.705L92.9905 164.474",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M162.735 73V90.6432C162.735 93.0407 164.678 94.9763 167.068 94.9763H190",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M145.02 113.256C145.02 113.256 153.981 107.29 145.02 98.3294",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M140.926 109.513C140.926 109.513 145.394 106.542 140.926 102.073",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M127.679 109.648H121.769C121.204 109.648 120.742 109.186 120.742 108.621V103.284C120.742 102.718 121.204 102.256 121.769 102.256H127.655C127.926 102.256 128.189 102.145 128.38 101.954L133.701 96.617C134.346 95.9638 135.461 96.4258 135.461 97.3418V114.236C135.461 115.136 134.378 115.606 133.725 114.985L128.38 109.927C128.189 109.744 127.934 109.648 127.671 109.648H127.679Z",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_577_171098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticle);
export default __webpack_public_path__ + "static/media/Article.5101c53bb9624367f989da1c672b5cc2.svg";
export { ForwardRef as ReactComponent };